import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const UserPopUpDisplay = ({
  display,
  setUserPopUp,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  companyInformation,
}) => {
  console.log("displa ", display);
  const [infoDisplay, setInfoDisplay] = useState("enatis");

  // get vehcle data

  // get task history

  // get fines hostry

  // get enatis data latest input

  // request account access and send message to user
  const RequestAccountAccess = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://locahost:3001" + "/agency/getAgencyCustomers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            agencyId: companyInformation._id,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        // setAgencyCustomerArray(respnseData.customers);

        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to find customers, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };
  // check for account permission and access
  const checkIfYouHaveAccess = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://locahost:3001" + "/agency/getAgencyCustomers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            agencyId: companyInformation._id,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        // setAgencyCustomerArray(respnseData.customers);

        // setToastPop(true);
        // setPopUpTitle("SUCCESS");
        // setMessage("Log-in successful");
        setLoading(false);

        // setToastPop(true);
      } else {
        setLoading(false);
        setPopUpTitle("FAILED");
        setMessage("Unable to find customers, " + " " + respnseData.message);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setLoading(false);
      setMessage(
        "Unable to login into account, please wait 5 mins then try again or contact support" +
          " " +
          err
      );
      setToastPop(true);
      console.log("error", err);
    }
  };
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        backgroundColor: colors.white,
        overflow: "hidden",
        height: display ? "100%" : 0,
        width: "100%",
        transition: "all 0.2s",
        display: "flex",
      }}
    >
      <div
        style={{
          top: 20,
          left: 20,
          position: "absolute",
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"BACK"}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          width={120}
          onClick={() => setUserPopUp(null)}
        />
        <div style={{ fontSize: 18, fontWeight: "bold", marginLeft: 10 }}>
          USER PROFILE
        </div>
      </div>
      <div
        style={{
          width: 400,
          minWidth: 400,
          height: "100%",
          WebkitBoxShadow: "0px 0px 7px 2px #00000050",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <div style={{ width: "90%", marginTop: 80 }}>
          <div style={{ fontWeight: "bold", marginBottom: 5, fontSize: 14 }}>
            Name
          </div>
          <div>
            {display ? display.firstName + " " + display.lastName : null}
          </div>
        </div>
        <div style={{ width: "90%", marginTop: 10 }}>
          <div style={{ fontWeight: "bold", marginBottom: 5, fontSize: 14 }}>
            Title
          </div>
          <div>{display ? display.title : null}</div>
        </div>
        <div style={{ width: "90%", marginTop: 10 }}>
          <div style={{ fontWeight: "bold", marginBottom: 5, fontSize: 14 }}>
            Email
          </div>
          <div>{display ? display.email : null}</div>
        </div>
        <div style={{ width: "90%", marginTop: 10 }}>
          <div style={{ fontWeight: "bold", marginBottom: 5, fontSize: 14 }}>
            Cell number
          </div>
          <div>{display ? display.cellNumber : null}</div>
        </div>
        <div style={{ width: "90%", marginTop: 10 }}>
          <div style={{ fontWeight: "bold", marginBottom: 5, fontSize: 14 }}>
            CONTACT ME ON WHATSAPP?
          </div>
          <div>
            {display ? (display.whatsAppContact === true ? "YES" : "NO") : null}
          </div>
        </div>
        <div style={{ marginTop: 20 }} />
        <BaseButtons
          label={"REQUEST ACCOUNT ACCESS"}
          width={"90%"}
          borderRadius={4}
          backgroundColor={colors.secondaryDarkBlue}
        />
      </div>
      <div
        style={{
          flex: 1,
          // borderStyle: "solid",
          width: 400,
          minWidth: 400,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "100%",
            minHeight: 50,
            backgroundColor: colors.secondaryDarkBlue,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <BaseButtons
            label={"VEHICLES"}
            backgroundColor={
              infoDisplay === "vehicles"
                ? colors.primaryBlue
                : colors.secondaryDarkBlue
            }
            width={120}
            height={50}
            onClick={() => setInfoDisplay("vehicles")}
          />
          <BaseButtons
            label={"TASKS"}
            backgroundColor={
              infoDisplay === "tasks"
                ? colors.primaryBlue
                : colors.secondaryDarkBlue
            }
            width={120}
            height={50}
            onClick={() => setInfoDisplay("tasks")}
          />
          <BaseButtons
            label={"FINES"}
            backgroundColor={
              infoDisplay === "fines"
                ? colors.primaryBlue
                : colors.secondaryDarkBlue
            }
            width={120}
            height={50}
            onClick={() => setInfoDisplay("fines")}
          />
          <BaseButtons
            label={"ENATIS"}
            backgroundColor={
              infoDisplay === "enatis"
                ? colors.primaryBlue
                : colors.secondaryDarkBlue
            }
            width={120}
            height={50}
            onClick={() => setInfoDisplay("enatis")}
          />
        </div>
        <div
          style={{
            flex: 1,
            position: "absolute",
            top: 0,
            width: "100%",
            backgroundColor: colors.primaryBlue50,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>YOU DO NOT HAVE PERMISSION ACCESS TO THIS INFORMATION </div>
        </div>
      </div>
    </div>
  );
};

export default UserPopUpDisplay;
